export const USERS_SETTINGS_STORE = "usersSettingsStore";
export const LOGINS_STORE = "loginsStore";
export const USER_LOGS_STORE = "userLogsStore";
export const LOGIN_LOGS_STORE = "loginLogsStore";
